import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import axios from 'axios';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchSizeInfoData } from '../../../sizeInfo/sizeInfo.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import { fetchYarnPOProgramDropdown, fetchYarnPOSalesOrderDropdown, fetchYarnPOSupplierDropdown } from '../../YarnPO/yarnPO/yarnPO.actions';


import {
    CREATE_GARMENTS_PO_FAILURE,
    CREATE_GARMENTS_PO_REQUEST,
    CREATE_GARMENTS_PO_SUCCESS,
    CREATE_USER_FORM_GARMENTS_PO,
    DELETE_GARMENTS_PO_FAILURE,
    DELETE_GARMENTS_PO_REQUEST,
    DELETE_GARMENTS_PO_SUCCESS,
    FETCH_SINGLE_GARMENTS_PO_FAILURE,
    FETCH_SINGLE_GARMENTS_PO_REQUEST,
    FETCH_SINGLE_GARMENTS_PO_SUCCESS,
    FETCH_GARMENTS_PO_FAILURE,
    FETCH_GARMENTS_PO_REQUEST,
    FETCH_GARMENTS_PO_SUCCESS,
    GARMENTS_PO_USERFORM_RESET,
    UPDATE_GARMENTS_PO_FAILURE,
    UPDATE_GARMENTS_PO_REQUEST,
    UPDATE_GARMENTS_PO_SUCCESS,
    GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_GARMENTS_PO_INVOICE_REQUEST,
    FETCH_GARMENTS_PO_INVOICE_SUCCESS,
    FETCH_GARMENTS_PO_INVOICE_FAILURE,
    FETCH_GARMENTS_PO_STYLE_REQUEST,
    FETCH_GARMENTS_PO_STYLE_SUCCESS,
    FETCH_GARMENTS_PO_STYLE_FAILURE,
    FETCH_GARMENTS_PO_FORMAT_REQUEST,
    FETCH_GARMENTS_PO_FORMAT_SUCCESS,
    FETCH_GARMENTS_PO_FORMAT_FAILURE,
    FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_REQUEST,
    FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_SUCCESS,
    FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_FAILURE,
    CLOSE_BTN_POST_FAILURE_GARMENTS,
    CLOSE_BTN_POST_SUCCESS_GARMENTS,
    CLOSE_BTN_POST_REQUEST_GARMENTS,
    DELETE_GARMENTS_PO_REQUEST_CALL_OFF,
    DELETE_GARMENTS_PO_SUCCESS_CALL_OFF,
    DELETE_GARMENTS_PO_FAILURE_CALL_OFF,
    DELETE_CALL_OFF_GARMENTS_PO_REQUEST,
    DELETE_CALL_OFF_GARMENTS_PO_FAILURE,
    DELETE_CALL_OFF_GARMENTS_PO_SUCCESS
} from './garmentsPo.actionsType';
import Config from '../../../../config';
import Cookies from 'js-cookie';

// FETCH PROPERTY MASTER
export let fetchGarmentsPO = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.garmentsPoMasterGET}?fromDate=${startDate}&toDate=${endDate}&FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_GARMENTS_PO_REQUEST,
        responseTypeSuccess: FETCH_GARMENTS_PO_SUCCESS,
        responseTypeFailure: FETCH_GARMENTS_PO_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createGarmentsUserform = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_GARMENTS_PO, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createGarmentsPOMaster = (formData, modalClose, startDate, endDate, unitId, isDetail) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldSupplierPANNo: 'static',
        fldSupplierPhoneNo: 'static',
        flDeliveryAtPANNo: 'static',
        fldDeliveryPhoneNo: 'static',
        ...formData,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        // fldFKFormatMaster: parseInt(formData.fldFKFormatMaster),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSizeInfo: 0,
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData?.fldDeliveryStartDate ? formData.fldDeliveryStartDate : today.toISOString(),
        fldDeliveryEndDate: formData?.fldDeliveryEndDate ? formData.fldDeliveryEndDate : today.toISOString(),
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? parseInt(formData.fldFKUnitId) : parseInt(formData.fldFKDeliveryAt),

        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),

        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: today.toISOString(),
        fldVerifyBy: '',
        fldVerifyDate: today.toISOString(),
        fldAuthorizeBy: '',
        fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldItemsSGSTValue: 0,
        fldItemsCGSTValue: 0,
        fldItemsIGSTValue: 0,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldDeliveryName: '',
        fldIsFinished: formData.fldIsFinished,
        fldIsReadyGarment: formData.fldIsReadyGarment

    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.garmentsPoMasterCREATE}`,
        responseTypeRequest: CREATE_GARMENTS_PO_REQUEST,
        responseTypeSuccess: CREATE_GARMENTS_PO_SUCCESS,
        responseTypeFailure: CREATE_GARMENTS_PO_FAILURE,
        resetFormData: isDetail ? GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB : GARMENTS_PO_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'DC',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchGarmentsPO(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleGarmentsPOMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.garmentsPOMasterByID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_GARMENTS_PO_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_GARMENTS_PO_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_GARMENTS_PO_FAILURE,
        singlApiArray: [
            fetchSeasonMaster(),
            fetchYarnPOSupplierDropdown('TblGarmentPO'),
            fetchCommonPropertyById(52),
            fetchCommonPropertyById(46),
            fetchCommonPropertyById(28),
            fetchUnitMaster(),
            fetchYarnPOProgramDropdown('TblGarmentPO'),
            // fetchYarnPOSalesOrderDropdown(),
            // fetchStyleMasterBasicDataWithSKU(),
            fetchSizeInfoData(),
            fetchGarmentsPOFormatGetList()
        ]
    };
    return axiosCall(config);
};

export let getGarmentsPOInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.garmentsPOInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_GARMENTS_PO_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_GARMENTS_PO_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_GARMENTS_PO_INVOICE_FAILURE
    };
    return axiosCall(config);
    // return (dispatch) => {
    //     dispatch({ type: FETCH_GARMENTS_PO_INVOICE_REQUEST });
    //     var config = {
    //         method: 'get',
    //         url: `${Config.baseUrl}${ConstantApi.cuttingDCInvoiceGET}/${id}`,
    //         headers: {
    //             // 'Access-Control-Allow-Origin': true,
    //             'Content-Type': 'application/json',
    //             Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
    //             dbname: Cookies.get('DATABASE')
    //         }
    //     };
    //     axios(config)
    //         .then((response) => {
    //             dispatch({ type: FETCH_GARMENTS_PO_INVOICE_SUCCESS, updatePayload: response.data });

    //             dispatch(fetchCuttingDCDetailsById(response?.data[0]?.FldFkDCNO));
    //         })
    //         .catch((error) => {
    //             dispatch({ type: FETCH_GARMENTS_PO_INVOICE_FAILURE, updatePayload: error });
    //         });
    // };
};

//UPDATE PROPERTY MASTER
export let updateGarmentsPOMaster = (formData, id, startDate, endDate, empty, unitId) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldFKFormatMaster: parseInt(formData.fldFKFormatMaster),
        // fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSizeInfo: parseInt(formData.fldFKSizeInfo),
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        // fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldIsFinished: formData.fldIsFinished,
        fldIsReadyGarment: formData.fldIsReadyGarment
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.garmentsPoMasterUPDATE}/${id}`,
        responseTypeRequest: UPDATE_GARMENTS_PO_REQUEST,
        responseTypeSuccess: UPDATE_GARMENTS_PO_SUCCESS,
        responseTypeFailure: UPDATE_GARMENTS_PO_FAILURE,
        resetFormData: GARMENTS_PO_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchGarmentsPO(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteGarmentsPOMaster = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.garmentsPoMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_GARMENTS_PO_REQUEST,
        responseTypeSuccess: DELETE_GARMENTS_PO_SUCCESS,
        responseTypeFailure: DELETE_GARMENTS_PO_FAILURE,
        modalClose: true,
        getAllData: fetchGarmentsPO(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let fetchGarmentsPOStyleGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCStyleMasterGET}?ActionCode=DYD`,
        responseTypeRequest: FETCH_GARMENTS_PO_STYLE_REQUEST,
        responseTypeSuccess: FETCH_GARMENTS_PO_STYLE_SUCCESS,
        responseTypeFailure: FETCH_GARMENTS_PO_STYLE_FAILURE
    };
    return axiosCall(config);
};

export let fetchGarmentsPOFormatGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCFormatMasterGET}`,
        responseTypeRequest: FETCH_GARMENTS_PO_FORMAT_REQUEST,
        responseTypeSuccess: FETCH_GARMENTS_PO_FORMAT_SUCCESS,
        responseTypeFailure: FETCH_GARMENTS_PO_FORMAT_FAILURE
    };
    return axiosCall(config);
};


export let fetchGarQtyWithSizeForPrint = (dc) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.garDCQtyWithSizeForPrintGET}?FldFKDCNO=${dc}`,
        responseTypeRequest: FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_REQUEST,
        responseTypeSuccess: FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_SUCCESS,
        responseTypeFailure: FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_FAILURE
    };
    return axiosCall(config);
};


export let PostCloseIconApiGarments = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconCUT}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_GARMENTS,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_GARMENTS,
        responseTypeFailure: CLOSE_BTN_POST_FAILURE_GARMENTS,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};


export let deleteGarmentsPOCallOff = (id) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.deleteDCDetailsCallOffGarments}/${id}`,
        responseTypeRequest: DELETE_GARMENTS_PO_REQUEST_CALL_OFF,
        responseTypeSuccess: DELETE_GARMENTS_PO_SUCCESS_CALL_OFF,
        responseTypeFailure: DELETE_GARMENTS_PO_FAILURE_CALL_OFF,
        // getAllData: fetchCuttingDCDetailsById(id)
    };
    return axiosCall(config);
};

export let deleteHeaderGarmentsPoCalloff = (id, reason, startDate, endDate, unitId) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.garmentPoCallOffwithReason}?FldId=${id}&FldReason=${reason}`,
        responseTypeRequest: DELETE_CALL_OFF_GARMENTS_PO_REQUEST,
        responseTypeSuccess: DELETE_CALL_OFF_GARMENTS_PO_SUCCESS,
        responseTypeFailure: DELETE_CALL_OFF_GARMENTS_PO_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchGarmentsPO(startDate, endDate, unitId)
    };
    return axiosCall(config);
};
